export const SIGNATURE_IMAGE = "SIGNATURE_IMAGE";
export const ID_DOCUMENT = "ID_DOCUMENT";
export const AFFILIATED_APPROVAL = "AFFILIATED_APPROVAL";
export const DOCUMENT = "DOCUMENT";
export const OTHER = "OTHER";
export const EMPLOYEES_UPLOAD_DOCUMENT = "BULK_USER_REGISTRATION_INFORMATION";
